import React from 'react'
import { CancelCheckoutButton as ContinueShoppingButtonCore } from '@ztechapps/order.webui'
import { useHistory } from '@ztechapps/common.hook'
import { routesDef } from '../../config/routes'

export const ContinueShoppingButton = () => {
  const history = useHistory()
  const onClick = () => {
    const route = routesDef.ProductListPage.altPath()
    history.push(route)
  }

  return <ContinueShoppingButtonCore onClick={onClick} />
}
